import {ChangeDetectionStrategy, Component, HostBinding, Input, OnInit, ViewEncapsulation} from '@angular/core';

@Component({
  selector: 'jd-loading-svg',
  template: `
    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
     width="24px" height="30px" viewBox="0 0 24 30" style="enable-background:new 0 0 50 50;" xml:space="preserve">
    <rect x="0" y="0" width="4" height="10" [attr.fill]="fillColor">
      <animateTransform attributeType="xml"
        attributeName="transform" type="translate"
        values="0 0; 0 20; 0 0"
        begin="0" dur="0.6s" repeatCount="indefinite" />
    </rect>
    <rect x="10" y="0" width="4" height="10" [attr.fill]="fillColor">
      <animateTransform attributeType="xml"
        attributeName="transform" type="translate"
        values="0 0; 0 20; 0 0"
        begin="0.2s" dur="0.6s" repeatCount="indefinite" />
    </rect>
    <rect x="20" y="0" width="4" height="10" [attr.fill]="fillColor">
      <animateTransform attributeType="xml"
        attributeName="transform" type="translate"
        values="0 0; 0 20; 0 0"
        begin="0.4s" dur="0.6s" repeatCount="indefinite" />
    </rect>
  </svg><div [style.color]="fillColor" class="loading-tip">{{tip}}</div>
  `,
  styles: [`
    .jd-loading-large svg {
      width: 45px;
      height: 55px;
    }
    .jd-loading-large .loading-tip {
      font-size: 18px;
    }
    .jd-loading-small svg {
      width: 35px;
      height: 45px;
    }
  `],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LoadingSvgComponent implements OnInit {

  @Input() size: 'large' | 'small' | 'default' = 'default';

  @Input() fillColor = '#FF6700';

  @Input() tip = 'å è½½ä¸­...';

  @HostBinding('class.jd-loading-large')
  get isLarge() {
    return this.size === 'large';
  }

  @HostBinding('class.jd-loading-small')
  get isSmall() {
    return this.size === 'small';
  }

  @HostBinding('class.jd-loading-default')
  get isDefault() {
    return this.size === 'default';
  }

  constructor() {
  }

  ngOnInit() {
  }

}
